import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class PhxDropdownService {
  public descendantMenuItemClick = new Subject<any>();
  public toggle$ = new Subject<boolean>();

  public onDescendantMenuItemClick(menu: any): void {
    this.descendantMenuItemClick.next(menu);
  }

  public close(){
    this.toggle$.next(false);
  }

  public open(){
    this.toggle$.next(true);
  }
}
